import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/pluck';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';

import { Log } from '../../../utils/index';
import { TrackerAdmin, Retailer, TrackerStatus, BreadcrumbItem, ITrackerFilter } from '../../../entities/index';
import { TrackerAdminService } from '../../../services/trackeradmin.service';
import { TaskService } from '../../../services/task.service';
import { TrackerStatusService } from '../../../services/trackerstatus.service';
import { RetailerService } from '../../../services/retailer.service';
import { TRACKER_FIRMWARES, TRACKER_TYPES } from '../../../services/constants.service';
import { ListComponent } from '../list.component';
import { RetailerShort } from '../../../entities/retailer.entity';

declare var jQuery: any;

@Component({
  selector: 'app-trackeradmin-list',
  templateUrl: './trackeradmin-list.html'
})
export class TrackeradminListComponent extends ListComponent implements OnInit {
  total$: Observable<number>;
  items$: Observable<TrackerAdmin[]>;
  trackerAdminForm: TrackerAdmin = new TrackerAdmin();

  trackerStatus: Promise<TrackerStatus[]>;
  retailers: Promise<RetailerShort[]>;

  firmwares: string[] = TRACKER_FIRMWARES;
  types: string[] = TRACKER_TYPES;

  pageTitle = 'TrackerAdmin List';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('TrackerAdmin List', 'map-marker')
  ];

  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected trackerAdminService: TrackerAdminService,
              protected taskService: TaskService,
              protected trackerStatusService: TrackerStatusService,
              protected notification: NotificationsService,
              protected retailerService: RetailerService) {
    super(route, trackerAdminService);
  }

  @Log()
  ngOnInit() {
    this.trackerStatus = this.trackerStatusService.getAll();
    this.retailers = this.retailerService.getAll();

    const source = this.createSource();
    this.total$ = source.pluck('total');
    this.items$ = source.pluck('items');

  }

  @Log('blue')
  applyFilter(trackerFilter: ITrackerFilter) {
    const source = this.createSource(trackerFilter);
    this.total$ = source.pluck('total');
    this.items$ = source.pluck('items');
  }

  @Log('blue')
  add() {
    this.trackerAdminForm = new TrackerAdmin();
    jQuery('.tracker').modal();
  }

  @Log('blue')
  save() {
    this.trackerAdminService.save(this.trackerAdminForm)
      .subscribe(() => {
        this._reloadList();
        jQuery('.tracker').modal('hide');
        this.notification.success('SUCCESS', 'The trackerAdmin has been saved.');
      });
  }

  toNumber(attribute: string) {
    this.trackerAdminForm[attribute] = +this.trackerAdminForm[attribute];
  }

  @Log('blue')
  remove(event: Event, entity: any) {
    event.stopPropagation();
    if (confirm('Are you sure you want to remove this item ?')) {
      this.trackerAdminService.remove(entity).subscribe(() => {
        this._reloadList();
        this.notification.success('SUCCESS', 'The trackerAdmin was removed.');
      });
    }
  }

  @Log('blue')
  importCsv(files: any) {
    this.trackerAdminService.importCsv(files[0]).subscribe((taskId: number) => {
      this.router.navigate(['/task', taskId]);
    });
  }

  @Log('blue')
  importFirmware(files: any) {
    this.taskService.firmwareOtaCsv(files[0]).subscribe((taskId: number) => {
      this.router.navigate(['/task', taskId]);
    });
  }

  getTermStorageKey(): string {
    return 'term_trackeradmin';
  }

  _reloadList() {
    this.terms = '';
    this.pageStream.next(1);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/trackeradmin/trackeradmin-list.component.ts